<div class="wow-consulta">
  <div class="wow-consulta__painel">
    <div class="wow-consulta__filtros" [class.wow-consulta__filtros--inline]="layoutInline">
      <div class="wow-consulta__campo" *ngIf="showConsultarPor && tipoFiltros?.length">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Consultar por</mat-label>
          <mat-select [value]="tipoFiltro" (valueChange)="onTipoFiltroChange($event)">
            <mat-option *ngFor="let f of tipoFiltros" [value]="f">{{ f }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="wow-consulta__campo" [class.wow-consulta__campo--wide]="parametroWide" *ngIf="showParametro">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ labelCampo }}</mat-label>
          <input matInput [value]="parametro" (input)="onParametroChange($any($event.target).value)"
            [mask]="parametroMask" [dropSpecialCharacters]="false">
        </mat-form-field>
      </div>

      <div class="wow-consulta__campo" *ngIf="showSituacao">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Situação</mat-label>
          <mat-select [value]="situacao" (valueChange)="onSituacaoChange($event)">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option [value]="true">Ativo</mat-option>
            <mat-option [value]="false">Inativo</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ng-content></ng-content>

      <div class="wow-consulta__btn-group">
        <button type="button" mat-stroked-button class="wow-consulta__btn-consultar" (click)="consultar.emit()">
          Consultar
        </button>
        <button type="button" mat-stroked-button class="wow-consulta__btn-novo" *ngIf="showNovo" (click)="novo.emit()">
          Novo
        </button>
      </div>
    </div>
  </div>
</div>
